export default "__VITE_ASSET__BkyPEyc0__"